






















import BaseComponent from '@/components/base-component.vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({
  components: {},
  directives: {}
})
export default class VisitResultDialog extends BaseComponent {
  @Prop()
  result: any;

  maxWidth = 650;

  dialogFlag = false;

  public $refs!: {
    form: HTMLFormElement;
  };

  mounted() {
    this.dialogFlag = true;
  }

  closeForm() {
    this.$emit('close');
  }

  openPlanning() {
    this.$emit('openPlanning', this.result);
  }
}
